import { useEffect, useState } from 'react';

/**
 * Observa si el body tiene la clase "menu-open" (controlada por theme-main.js)
 * y devuelve un boolean reactivo. No modifica el DOM.
 */
export function useMenuOpen() {
  const [isMenuOpen, setIsMenuOpen] = useState(
    () => document.body.classList.contains('menu-open')
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsMenuOpen(document.body.classList.contains('menu-open'));
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  return isMenuOpen;
}